import PriorityQueue from "peculiar/priority-queue";

function logEvent(message) {
  document.dispatchEvent(new CustomEvent("game.event", {
    detail: {
      message,
    }
  }));
}

function initializeUpdateSchedule(stage) {
  const schedule = new PriorityQueue();

  for (const entity of stage.entities) {
    if (entity.canTakeTurn()) {
      schedule.push(entity, entity.actionDelay());
    }
  }

  let isRunning = true;

  return function update() {
    while (isRunning) {
      if (schedule.peek().needsInput()) return;
      const [entity, priority] = schedule.pollIndex();
      schedule.adjustBy(-priority);

      // TODO: more robust scheduling to handle when the stage changes
      try {
        if (entity.takeTurn(stage)) {
          schedule.push(entity, entity.actionDelay());
        } else {
          stage.removeEntity(entity);
        }
      } catch(err) {
        // Handles race condition where stage has been updated but
        // schedule has already been called on the animation frame
        isRunning = false;
        console.error(err);
        throw new Error(err);
      }
    }
  }
}


export { initializeUpdateSchedule }
